import React, { useState } from 'react';

import Text from '../../../../../BaseModule/Components/Text';
import AddFamilyMemberModal from '../../../../../Family/Components/AddFamilyMember/AddFamilyMemberModal';
import styles from './UserPickerAdd.module.scss';

const UserPickerAdd: React.FC = () => {
	const [isAddOpen, setIsAddOpen] = useState(false);

	return (
		<>
			<div onClick={() => setIsAddOpen(true)} className={styles.wrapper}>
				<div className={styles.icon}>
					<img src='/dist/patientV3/icons/plus-purple.svg' alt='plus' />
				</div>
				<Text className={styles.text} tx='base.shared.add' firstUpper />
			</div>
			{isAddOpen && (
				<AddFamilyMemberModal isOpen onClose={() => setIsAddOpen(false)} />
			)}
		</>
	);
};

export default UserPickerAdd;
